<div *ngVar="editing$ | async as editing" class="flex flex-col gap-6">
  @if (editing) {
    <div
      class="flex flex-col self-center justify-center items-center gap-1 text-center max-w-250 px-6"
    >
      <div class="text-2xl text-navy-70 font-bold">
        {{ buildTranslationKey('whichRequirementsAreDisplayed') | translate }}
      </div>
      <div class="text-2xl text-navy-70">
        {{ buildTranslationKey('whichRequirementsAreDisplayedDescription') | translate }}
      </div>
    </div>
  }

  <div cdkDropListGroup class="controls-container grid grid-cols-1 lg:grid-cols-2 gap-5 px-6 pb-6">
    <div
      #placeholder
      cdkDropList
      class="placeholder-drop-list"
      [cdkDropListDisabled]="!editing"
      (cdkDropListEntered)="onDropListEntered($event)"
      (cdkDropListDropped)="onDropListDropped()"
    ></div>
    @for (category of categories; track category.name) {
      @if (isCategoryDraggable(category)) {
        <div
          cdkDropList
          [cdkDropListDisabled]="!editing"
          (cdkDropListEntered)="onDropListEntered($event)"
          (cdkDropListDropped)="onDropListDropped()"
        >
          <app-control-summary
            cdkDrag
            cdkDragBoundary=".controls-container"
            [cdkDragData]="category"
            [control]="category"
          >
            @if (editing) {
              <app-new-button
                cdkDragHandle
                class="cdk-drag-handle top-0 left-0 h-10 w-10 bg-navy-40 border border-navy-60 transform -translate-x-1/2 -translate-y-1/2"
                [svgIconPath]="'drag'"
                [isOnlyIcon]="true"
                [type]="'basic'"
                [size]="'tiny'"
              ></app-new-button>
            }
          </app-control-summary>
        </div>
      } @else {
        <app-control-summary [control]="category"></app-control-summary>
      }
    }
  </div>
</div>
